export default __webpack_public_path__ + "9f78610e626b3c8fc9633d8f2190e3ff.svg";